module.exports = __webpack_public_path__ + "assets/img/sweep-project.9cb2d11a.png";